import React, { useEffect, useState } from 'react';
import "./yewutaishi.css"
import UseTimeDay from './useTimeDay';
import UseTimeMonth from './useTimeMonth';
import UseTimeYear from './useTimeYear';
import UseMap from './useMap';
import Box from '../main/box';
import UseRank from './useRank';
import UseMapClass from './useMapClass';
const Yewurtaishi: React.FC<{}> = () => {
  const [useRegionData, setUseRegionData] = useState<any[]>([])

  return (
    <div className='allBack'>
      <div className='title'>Business Dashboard</div>
      <div className="content">
      <div className='business-mask-left'></div>
      <div className='business-mask-right'></div>
        <div className='Left'>
          <div className='useTime'>
            <Box
              title="Annual Average Usage"
              component={
                <UseTimeYear nowData={30} />
              }
            />
          </div>
          <div className='useTime'>
            <Box
              title="Monthly Average Usage"
              component={
                <UseTimeMonth nowData={30} />
              }
            />
          </div>
          <div className='useTime'>
            <Box
              title="Daily Average Usage"
              component={
                <UseTimeDay nowData={1} />
              }
            />
          </div>

        </div>
        <div className='useMap'>
          <Box
            title="Usage by Region"
            component={
              <UseMap nowData={1}  setUseRegionData = {setUseRegionData}/>
            }
          />
        </div>
        <div className='right'>
          <div className='useRank'>
            <Box
              title="Regional Ranking"
              component={
                <UseRank nowData={useRegionData} />
              }
            />
          </div>
          <div className='useRegionMap'>
            <Box
              title="Time Distribution"
              component={
                <UseMapClass nowData={1} />
              }
            />

          </div>
        </div>

      </div>

    </div>
  );
}

export default Yewurtaishi;